'use strict';
import {shopModule} from '../module.js';
import {ShopServiceApiVersion} from '@nuskin/ns-shop';
import {getCachedConfigField} from '@nuskin/configuration-sdk';

shopModule.factory('nsPostalCodeService', ['$resource', function($resource) {
    return $resource(ShopServiceApiVersion.getPostalCodeServiceVersionedUrl(
        getCachedConfigField('postalCodeServiceUrl')
    ));
}]);

